export default "__VITE_ASSET__48450681__"